import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs as HeroBreadcrumbs } from '@heroui/react';
export const Breadcrumbs = (props) => {
    return _jsx(HeroBreadcrumbs, { ...props });
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map